"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ExclamationIcon = _interopRequireDefault(require("../Icons/ExclamationIcon"));

var _QuestionIcon = _interopRequireDefault(require("../Icons/QuestionIcon"));

var _CheckMarkIcon = _interopRequireDefault(require("../Icons/CheckMarkIcon"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * The StatusIcon component is used to indicate a status. Generally it used in
 * combination with a tooltip to a show status message on hover. By default
 * this StatusIcon get a exclamation mark but also question mark and check mark
 * are available.
 *
 * Recommended usage: http://nutanix.design/2.0/#Components_TagsandBadges
 */
var StatusIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StatusIcon, _React$Component);

  function StatusIcon() {
    _classCallCheck(this, StatusIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(StatusIcon).apply(this, arguments));
  }

  _createClass(StatusIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          tooltipProps = _this$props.tooltipProps,
          iconProps = _this$props.iconProps;
      var iconColor = 'white';
      var iconSize = 'small';
      var typeSelected = {
        alert: {
          icon: _react.default.createElement(_ExclamationIcon.default, {
            color: iconColor,
            size: iconSize
          }),
          color: 'red'
        },
        warning: {
          icon: _react.default.createElement(_ExclamationIcon.default, {
            color: iconColor,
            size: iconSize
          }),
          color: 'yellow'
        },
        question: {
          icon: _react.default.createElement(_QuestionIcon.default, {
            color: iconColor,
            size: iconSize
          }),
          color: 'gray'
        },
        valid: {
          icon: _react.default.createElement(_CheckMarkIcon.default, {
            color: iconColor,
            size: iconSize
          }),
          color: 'green'
        }
      }[type];
      var mergedClassName = (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-status-icon"), typeSelected.color);

      var icon = _react.default.cloneElement(typeSelected.icon, iconProps);

      return _react.default.createElement(_Tooltip.default, tooltipProps, _react.default.createElement(_FlexLayout.default, {
        className: mergedClassName,
        display: "inline-flex",
        alignItems: "center"
      }, icon));
    }
  }]);

  return StatusIcon;
}(_react.default.Component);

exports.default = StatusIcon;
StatusIcon.STATUS_ICON_TYPES = {
  ALERT: 'alert',
  WARNING: 'warning',
  QUESTION: 'question',
  VALID: 'valid'
};
StatusIcon.defaultProps = {
  type: StatusIcon.STATUS_ICON_TYPES.ALERT
};
StatusIcon.propTypes = {
  /**
   * Optional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * Type (Use StatusIcon.STATUS\_ICON\_TYPES constants)
   */
  type: _propTypes.default.oneOf([StatusIcon.STATUS_ICON_TYPES.ALERT, StatusIcon.STATUS_ICON_TYPES.WARNING, StatusIcon.STATUS_ICON_TYPES.QUESTION, StatusIcon.STATUS_ICON_TYPES.VALID]),

  /**
   * See Tooltip component for proper usage
   */
  tooltipProps: _propTypes.default.object.isRequired,

  /**
   * Props to be passed to the status icon
   */
  iconProps: _propTypes.default.object
};